const processActionTypes = {
  PROCESS_FILTER_REQUEST: 'PROCESS_FILTER_FETCH',
  PROCESS_FILTER_SUCCESS: 'PROCESS_FILTER_SUCCESS',
  PROCESS_FILTER_FAILURE: 'PROCESS_FILTER_FAILURE',
  PROCESS_START_FETCH: 'PROCESS_START_FETCH',
  PROCESS_SET_ERROR: 'PROCESS_SET_ERROR',
  PROCESS_REMOVE_ERROR: 'PROCESS_REMOVE_ERROR',
  FETCH_ALL_PROCESS_REQUEST: 'FETCH_ALL_PROCESS_REQUEST',
  FETCH_ALL_PROCESS_SUCCESS: 'FETCH_ALL_PROCESS_SUCCESS',
  FETCH_ALL_PROCESS_FAILURE: 'FETCH_ALL_PROCESS_FAILURE',
  REMOVE_ALL_PROCESS: 'REMOVE_ALL_PROCESS',
  UPDATE_ALL_PROCESS: 'UPDATE_ALL_PROCESS',
  UPDATE_PROCESS_STATUS: 'UPDATE_PROCESS_STATUS',
  REMOVE_PROCESS_BY_ID: 'REMOVE_PROCESS_BY_ID',
  REMOVE_PROCESS_POPUP: 'REMOVE_PROCESS_POPUP',
  FETCH_PROCESS_LOGS_REQUEST: 'FETCH_PROCESS_LOGS_REQUEST',
  FETCH_PROCESS_LOGS_SUCCESS: 'FETCH_PROCESS_LOGS_SUCCESS',
  FETCH_PROCESS_LOGS_FAILURE: 'FETCH_PROCESS_LOGS_FAILURE',
  REMOVE_PROCESS_LOGS: 'REMOVE_PROCESS_LOGS',
  CREATE_PROCESS_REQUEST: 'CREATE_PROCESS_REQUEST',
  CREATE_PROCESS_SUCCESS: 'CREATE_PROCESS_SUCCESS',
  CREATE_PROCESS_FAILURE: 'CREATE_PROCESS_FAILURE',
  SCHEDULE_PROCESS_SUCCESS: 'SCHEDULE_PROCESS_SUCCESS',
  SCHEDULE_PROCESS_FAILURE: 'SCHEDULE_PROCESS_FAILURE',
  REMOVE_SCHEDULE_PROCESS_POPUP: 'REMOVE_SCHEDULE_PROCESS_POPUP',
  FETCH_SCHEDULED_PROCESS_SUCCESS: 'FETCH_SCHEDULED_PROCESS_SUCCESS',
  FETCH_SCHEDULED_PROCESS_FAILURE: 'FETCH_SCHEDULED_PROCESS_FAILURE',
  FETCH_SCHEDULED_PROCESS_HISTORY_SUCCESS: 'FETCH_SCHEDULED_PROCESS_HISTORY_SUCCESS',
  FETCH_SCHEDULED_PROCESS_HISTORY_FAILURE: 'FETCH_SCHEDULED_PROCESS_HISTORY_FAILURE',
  REMOVE_SCHEDULED_PROCESS: 'REMOVE_SCHEDULED_PROCESS',
  DELETE_SCHEDULED_PROCESS_SUCCESS: 'DELETE_SCHEDULED_PROCESS_SUCCESS',
  DELETE_SCHEDULED_PROCESS_FAILURE: 'DELETE_SCHEDULED_PROCESS_FAILURE',
  FETCH_SCHEDULED_PROCESS_DETAILS_SUCCESS: 'FETCH_SCHEDULED_PROCESS_DETAILS_SUCCESS',
  FETCH_SCHEDULED_PROCESS_DETAILS_FAILURE: 'FETCH_SCHEDULED_PROCESS_DETAILS_FAILURE',
  REMOVE_SCHEDULED_PROCESS_DETAILS_POPUP: 'REMOVE_SCHEDULED_PROCESS_DETAILS_POPUP',
  REMOVE_SCHEDULED_PROCESS_DETAILS: 'REMOVE_SCHEDULED_PROCESS_DETAILS',
  SCHEDULE_LOGS_REQUEST: 'SCHEDULE_LOGS_REQUEST',
  SCHEDULE_LOGS_SUCCESS: 'SCHEDULE_LOGS_SUCCESS',
  SCHEDULE_LOGS_FAILURE: 'SCHEDULE_LOGS_FAILURE',
  PROCESS_EXECUTION_LOGS_REQUEST: 'PROCESS_EXECUTION_LOGS_REQUEST',
  PROCESS_EXECUTION_LOGS_SUCCESS: 'PROCESS_EXECUTION_LOGS_SUCCESS',
  PROCESS_EXECUTION_LOGS_FAILURE: 'PROCESS_EXECUTION_LOGS_FAILURE',

  PROCESS_CURRENT_STATUS_REQUEST: 'PROCESS_CURRENT_STATUS_REQUEST',
  PROCESS_CURRENT_STATUS_SUCCESS: 'PROCESS_CURRENT_STATUS_SUCCESS',
  PROCESS_CURRENT_STATUS_FAILURE: 'PROCESS_CURRENT_STATUS_FAILURE',

  BULK_CANCELLATION_SUCCESS: 'BULK_CANCELLATION_SUCCESS',
  REMOVE_BULK_CANCELLATION_SUCCESS_DETAILS: 'REMOVE_BULK_CANCELLATION_SUCCESS_DETAILS',
  BULK_CANCELLATION_FAILURE: 'BULK_CANCELLATION_FAILURE',
  GET_SCHEDULE_BACKBTN_SUCCESS: 'GET_SCHEDULE_BACKBTN_SUCCESS',
  GET_SCHEDULE_BACKBTN_FAILURE: 'GET_SCHEDULE_BACKBTN_FAILURE',
  UPDATE_SCHEDULE_PAGE: 'UPDATE_SCHEDULE_PAGE',
};

export default processActionTypes;
